import { inject, Injectable } from '@angular/core';
import { IEnricherCriteriaDTO } from '../dto/enricher.criteria.dto';
import { IEnricherModel } from '../model/enricher.model';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ENV_CONFIG } from '@libs/vc-core-lib';

@Injectable({
    providedIn: 'root',
})
export class EnricherService {
    private readonly _enricherPath: string = 'enrichers';

    private readonly _environment = inject(ENV_CONFIG);
    private readonly _httpClient = inject(HttpClient);

    public searchWithoutPaging(searchDTO: IEnricherCriteriaDTO): Observable<IEnricherModel[]> {
        return this._httpClient.post<IEnricherModel[]>(
            `${this._environment.APP.VC_EVENT_DECORATOR_BASE_URL}/${this._enricherPath}/search`,
            searchDTO
        );
    }

    public get(id: number): Observable<IEnricherModel> {
        return this._httpClient.get<IEnricherModel>(
            `${this._environment.APP.VC_EVENT_DECORATOR_BASE_URL}/${this._enricherPath}/${id}`
        );
    }

    public upsert(model: IEnricherModel): Observable<string> {
        return this._httpClient.post(
            `${this._environment.APP.VC_EVENT_DECORATOR_BASE_URL}/${this._enricherPath}`,
            model,
            {
                responseType: 'text',
            }
        );
    }

    public delete(id: number): Observable<void> {
        return this._httpClient.delete<void>(
            `${this._environment.APP.VC_EVENT_DECORATOR_BASE_URL}/${this._enricherPath}/${id}`
        );
    }
}
